import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/** Fetch brand info (company name + logo). Public endpoint so Login can use it too. */
export default function useBrand() {
  const [brand, setBrand] = useState({
    company_name: "Gogojalan",
    tagline: "Go Easy · Go Smart",
    logo_data_url: "",
  });

  useEffect(() => {
    axios.get(`${API}/brand`).then((r) => setBrand(r.data)).catch(() => {});
    const onUpdate = () => axios.get(`${API}/brand`).then((r) => setBrand(r.data));
    window.addEventListener("brand-updated", onUpdate);
    return () => window.removeEventListener("brand-updated", onUpdate);
  }, []);

  return brand;
}

/** Component: renders the uploaded logo if available; else the circular G mark. */
export function BrandMark({ brand, size = 40, className = "" }) {
  if (brand?.logo_data_url) {
    return (
      <img
        src={brand.logo_data_url}
        alt={brand.company_name}
        style={{ width: size, height: size, objectFit: "contain" }}
        className={`rounded-xl bg-white ${className}`}
      />
    );
  }
  return (
    <div className={`brand-mark ${className}`} style={{ width: size, height: size, fontSize: size * 0.5 }}>
      G
    </div>
  );
}
